import React from 'react';
import {faTimes, faEye} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import "./OverviewListItem.css";

export const OverviewListItem = ({text, onItemClick, onViewClick, onDeleteClick, buttonThreeText, disableDelete}) => {

    return (
        <div className="overview-list-item-container">
            <div className="overview-list-item-text-container">
                {text}
            </div>
            <div className="overview-list-item-view-button" aria-label={"overview-view"}  onClick={onViewClick}>
                <FontAwesomeIcon icon={faEye}/>
            </div>
            {buttonThreeText && <div className="overview-list-item-view-children-button" onClick={onItemClick}>
                {buttonThreeText}
            </div>}
            <div aria-label={"overview-delete"} className={"overview-list-item-delete-button " + (disableDelete ? "disable-delete" : null)}
                 onClick={() => {
                     if (!disableDelete) {
                         onDeleteClick()
                     }
                 }}>
                <FontAwesomeIcon icon={faTimes}/>
            </div>
        </div>
    );
}
